// src/components/ForgotPassword.js

import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom'; // 👈 On garde l'import de useNavigate pour l'instant
import axios from 'axios';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    // const navigate = useNavigate(); // ❌ SUPPRIMÉ : Cette ligne est à retirer pour éliminer l'avertissement
    
    // Si vous décidez de ne pas la supprimer, vous devez la commenter ou l'utiliser.
    // Pour l'instant, nous la retirons pour corriger l'avertissement.
    useNavigate(); // 👈 Si on ne l'utilise pas, on garde juste l'appel pour maintenir l'import sans initialiser une variable

    const onChange = e => setEmail(e.target.value);

    const onSubmit = async e => {
        e.preventDefault();
        try {
            // Remplacez cette URL par l'URL de votre backend pour gérer la demande de mot de passe oublié
            const res = await axios.post('https://api.blackroq.pro/api/auth/forgot-password', { email });
            
            // OPTIONNEL : Vous pourriez rediriger après le succès
            // if (res.data.success) {
            //    navigate('/login'); // Utilisation de 'navigate' ici
            // }
            
            setMessage(res.data.msg); // Affiche le message de succès du serveur
        } catch (err) {
            console.error(err.response.data);
            setMessage(err.response.data.msg || 'Erreur lors de l\'envoi de l\'e-mail. Veuillez réessayer.');
        }
    };

    return (
        <div className="container mt-5">
            <div className="row justify-content-center">
                <div className="col-md-6">
                    <div className="card shadow p-4">
                        <h1 className="text-center mb-4">Mot de passe oublié ?</h1>
                        <p className="text-center text-muted">
                            Entrez votre adresse e-mail pour recevoir un lien de réinitialisation.
                        </p>
                        {message && (
                            <div className={`alert ${message.includes('succès') ? 'alert-success' : 'alert-danger'}`}>
                                {message}
                            </div>
                        )}
                        <form onSubmit={onSubmit}>
                            <div className="mb-3">
                                <input
                                    type="email"
                                    className="form-control"
                                    placeholder="Votre adresse e-mail"
                                    name="email"
                                    value={email}
                                    onChange={onChange}
                                    required
                                />
                            </div>
                            <div className="d-grid gap-2">
                                <button type="submit" className="btn btn-primary">Envoyer le lien</button>
                            </div>
                        </form>
                        <p className="mt-3 text-center">
                            <Link to="/">Retour à la connexion</Link>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;